<template>
	<v-sheet elevation="0">
		<!-- <FunctionTitle title="" /> -->
		<CommonFlame :title="'テスト用案件作成'" class="mt-2">
			<!-- app-barに表示するボタン群 -->
			<template>
				<p class="text-center">
					動作テスト用の機能です。登録済みの情報からランダムに案件情報を作成します。実際の環境ではこの機能はありません。
				</p>
				<v-form class="pa-2" ref="form" v-model="valid">
					<v-row class="d-flex flex-wrap justify-center" no-gutters>
						<v-select
							v-model="ordered_flag"
							label="受注済みかどうか"
							:items="[
								{ name: '受注済み', value: 'true' },
								{ name: '未受注', value: 'false' },
							]"
							class="mt-2 mx-1"
							item-text="name"
							item-value="value"
							dense
							outlined
							style="max-width: 200px"
							hide-details="auto"
						/>
						<v-select
							v-model="situation"
							label="受注確度"
							:items="['A', 'B', 'C', 'D', 'E', 'F', 'S']"
							class="mt-2 mx-1"
							item-text="name"
							item-value="value"
							dense
							outlined
							style="max-width: 200px"
							hide-details="auto"
						/>
					</v-row>
				</v-form>
				<v-row no-gutters class="pb-2">
					<v-col cols="4"> </v-col>
					<v-col cols="4">
						<v-row no-gutters justify="center">
							<v-btn color="secondary" @click="createMatter">
								<v-icon class="mr-2">mdi-checkbox-marked-outline</v-icon>
								作成する
							</v-btn>
						</v-row>
					</v-col>
				</v-row>
			</template>
		</CommonFlame>
	</v-sheet>
</template>

<script>
import moment from "moment"
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import rules from "../../helper/rules"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"
export default {
	components: {
		FunctionTitle,
		CommonFlame,
	},
	data() {
		return {
			ordered_flag: "",
			situation: "",
			valid: false,
		}
	},
	created() {},
	methods: {
		createMatter() {
			const headers = authenticate.setHeader()
			headers["Content-type"] = "multipart/form-data"
			var formData = new FormData()
			formData.set("ordered_flag", this.ordered_flag)
			formData.set("situation", this.situation)
			axios
				.post("/erp/v1/trial_matters", formData, { headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						text: "作成しました",
						type: "notice",
					})
					this.ordered_flag = null
					this.situation = ""
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	watch: {},
}
</script>

<style scoped lang="scss">
.width50p {
	width: 45%;
}
@media (max-width: 600px) {
	.width50p {
		width: 100%;
	}
}
.hover-large {
	cursor: pointer;
	&:hover {
		font-size: 0.9rem !important;
	}
}
</style>
